module.exports = __webpack_public_path__ + "static/media/Polarimetry_analyzer-1.2ddc8d6e.png";